import {
	Environment,
	Network,
	RecordSource,
	RequestParameters,
	Store,
	Variables,
} from 'relay-runtime';

const LOCAL_API_URL = 'https://itnonstop-dev.dataart.com/umbraco/graphql/';

const url =
	process.env.NODE_ENV === 'production'
		? require('../env.json').API_URL
		: LOCAL_API_URL;

export function fetchQuery(operation: RequestParameters, variables: Variables) {
	return fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			query: operation.text,
			variables,
		}),
	}).then((response) => response.json());
}

const environment = new Environment({
	network: Network.create(fetchQuery),
	store: new Store(new RecordSource()),
});

export default environment;
